import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ProductsSection from '../components/ProductsSection';
import OriginSection from '../components/OriginSection';
import LogisticsSection from '../components/LogisticsSection';
import ContactSection from '../components/ContactSection';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ProductsSection />
        <OriginSection />
        <LogisticsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
